// logger.js
const isDevelopment = process.env.NEXT_PUBLIC_NODE_ENV === 'development';

export const log = (...args) => {
    if (isDevelopment) {
        console.log(...args);
    }
};